import { render, staticRenderFns } from "./RelatedAppointments.vue?vue&type=template&id=40b36083&"
import script from "./RelatedAppointments.vue?vue&type=script&lang=js&"
export * from "./RelatedAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports